import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { de } from "./locales/de";
import { en } from "./locales/en";
import { tr } from "./locales/tr";
export const dictionaries = {
  de,
  en,
  tr
};
export const languages = [{
  code: "de",
  label: "Deutsch",
  short: "DE"
}, {
  code: "en",
  label: "English",
  short: "EN"
}, {
  code: "tr",
  label: "Türkçe",
  short: "TR"
}];
const STORAGE_KEY = "bgu-lang";
const LanguageContext = createContext({
  lang: "de",
  setLang: () => {},
  t: de
});
function isLang(v) {
  return v === "de" || v === "en" || v === "tr";
}
export function LanguageProvider({
  children
}) {
  // Deutsch ist Standard und damit auch die Sprache des Server-Renderings.
  const [lang, setLangState] = useState("de");
  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (isLang(stored)) {
      setLangState(stored);
      return;
    }
    const nav = window.navigator.language?.slice(0, 2).toLowerCase();
    if (nav === "tr" || nav === "en") setLangState(nav);
  }, []);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo(() => ({
    lang,
    t: dictionaries[lang],
    setLang: l => {
      setLangState(l);
      try {
        window.localStorage.setItem(STORAGE_KEY, l);
      } catch {
        // Speichern ist optional.
      }
    }
  }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
export function useLang() {
  const {
    lang,
    setLang
  } = useContext(LanguageContext);
  return {
    lang,
    setLang
  };
}
export function useT() {
  return useContext(LanguageContext).t;
}